import { Icon } from '../../../layout/Icon.jsx';

/** نفس هيكل نوافذ النظام (features/shifts/components/ShiftModals.jsx). */
export function PlatformModal({ title, sub, onClose, children, footer, width = 460 }) {
  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4" style={{ background: 'rgba(15,16,18,0.5)' }}>
      <div
        className="bg-white rounded-[14px] shadow-card w-full overflow-hidden max-h-[92vh] flex flex-col"
        style={{ maxWidth: width }}
      >
        <div className="card-h">
          <div className="flex-1">
            <h3 className="text-[15px] font-bold m-0">{title}</h3>
            {sub ? <div className="text-[11.5px] text-ink-3 mt-0.5">{sub}</div> : null}
          </div>
          {onClose ? (
            <button type="button" className="text-ink-3 hover:text-ink" onClick={onClose} title="إغلاق">
              <Icon name="x" size={16} />
            </button>
          ) : null}
        </div>
        <div className="p-4 space-y-3 overflow-y-auto">{children}</div>
        {footer ? <div className="card-h border-b-0 border-t flex gap-2">{footer}</div> : null}
      </div>
    </div>
  );
}

export function Field({ label, required, hint, error, children }) {
  return (
    <div>
      <label className="block text-xs font-semibold text-ink-2 mb-1">
        {label} {required ? <span className="text-red">*</span> : null}
      </label>
      {children}
      {error ? (
        <div className="text-red text-[11.5px] mt-1 font-semibold">{error}</div>
      ) : hint ? (
        <div className="text-[11px] text-ink-3 mt-1">{hint}</div>
      ) : null}
    </div>
  );
}

export function Row({ label, children }) {
  return (
    <div className="flex items-start justify-between gap-3 text-[12.5px] py-1 border-b border-line last:border-b-0">
      <span className="text-ink-3 shrink-0">{label}</span>
      <span className="font-semibold text-left break-all">{children}</span>
    </div>
  );
}
